import { useState } from 'react';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import '../../../../../Preview/assets/Swiper.css';
import { Video } from '../../../../../Preview/Video';

export type SliderProps = {
  mediaDatas: string[];
  index: number;
  height: number;
  width: number;
};

const SliderDots = ({ activeIndex, datas }: { activeIndex: number; datas: string[] }) => {
  const swiper = useSwiper();

  const disableClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };
  return (
    <div className="mt-2 flex items-center justify-center">
      {datas.map((_, index) => {
        return (
          <button
            key={index}
            className={`m-1 aspect-square w-[8px] rounded-full ${
              activeIndex === index ? 'bg-[#007AFF]' : 'bg-black opacity-20'
            }`}
            onClick={(event: React.MouseEvent) => {
              disableClick(event);
              swiper.slideTo(index);
            }}
          />
        );
      })}
    </div>
  );
};

export const Slider = (props: SliderProps) => {
  const heightCss = `h-[${props.height}px]`;
  const widthCss = `w-[${props.width}px]`;
  const [activeIndex, setActiveIndex] = useState<number>(0);

  return (
    <div>
      <Swiper
        spaceBetween={50}
        slidesPerView={'auto'}
        direction={'horizontal'}
        onSlideChange={(swiper: any) => {
          setActiveIndex(swiper.activeIndex);
        }}
      >
        <div className={`flex items-center justify-center`}>
          {props.mediaDatas.map((src, index) => {
            const isVideo = src.endsWith('.mp4');
            const content = isVideo ? (
              <Video url={src} className={`${widthCss} ${heightCss}`} />
            ) : (
              <img src={src} alt={`media-${index}`} className={`w-[100%] rounded-lg object-contain`} />
            );
            return <SwiperSlide key={index}>{content}</SwiperSlide>;
          })}
        </div>
        <SliderDots activeIndex={activeIndex} datas={props.mediaDatas} />
      </Swiper>
    </div>
  );
};
